var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasCookie !== true)?_c('div',{attrs:{"id":"disclaimer"}},[_c('div',{staticClass:"disclaimer-container"},[_c('span',[_vm._v("This site uses cookies and external scripts to improve your experience.")]),_c('button',{staticClass:"button",on:{"click":_vm.accept}},[_vm._v("ACCEPT")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }